function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { Body, Container, Heading, PlatformIcon } from "../../atoms";
import { ProfileImage } from "../../molecules";
import ReactConfigContext from "../../ReactConfigContext";
export default function WorkgroupHero(param) {
    var title = param.title, subtitle = param.subtitle, description = param.description, links = param.links, image = param.image, accentColor = param.accentColor, socialItems = param.socialItems, badges = param.badges, className = param.className;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, LinkComponent = _useContext_config.LinkComponent, ImageComponent = _useContext_config.ImageComponent;
    return /*#__PURE__*/ React.createElement(Container, {
        name: WorkgroupHero.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-4 md:gap-9 md:grid-cols-[15.875rem_1fr]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full max-w-[7rem] mx-auto sm:max-w-[12rem] md:max-w-none md:mx-0"
    }, /*#__PURE__*/ React.createElement(ProfileImage, {
        image: image,
        color: accentColor,
        accent: "desktop-only"
    })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "text-center md:text-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-4"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: "h1"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-7 md:gap-5 md:grid-cols-[1fr_auto]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-4"
    }, !!subtitle && /*#__PURE__*/ React.createElement(Body, {
        className: "text-heading-h3-desktop text-link-fg-base"
    }, subtitle), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-3"
    }, !!description && /*#__PURE__*/ React.createElement(Body, {
        variant: "sm",
        className: "prose"
    }, description), links === null || links === void 0 ? void 0 : links.map(function(link) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: link.href
        }, link), {
            className: twMerge("text-link-fg-base font-semibold underline text-body-small", link.className)
        }), link.label);
    })), !!(socialItems === null || socialItems === void 0 ? void 0 : socialItems.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-5"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex -mx-4 justify-center items-center md:justify-start"
    }, socialItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: "socialitem-".concat(item.platform, "-").concat(item.href)
        }, item), {
            className: twMerge("mx-4 text-link-fg-base", item.className)
        }), /*#__PURE__*/ React.createElement(PlatformIcon, {
            type: item.platform,
            size: "1.125rem",
            "aria-label": item.title
        }));
    })))), !!(badges === null || badges === void 0 ? void 0 : badges.length) && /*#__PURE__*/ React.createElement("div", {
        className: "pl-5 mt-auto mx-auto md:mx-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row -m-2 md:flex-col"
    }, badges.map(function(badge) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: badge.action.href
        }, badge.action), {
            className: twMerge("w-[7.75rem] h-[7.75rem] rounded-full m-2 overflow-hidden", "md:w-[6.25rem] md:h-[6.25rem]", badge.action.className)
        }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, badge.image), {
            className: twMerge("block w-full h-full object-cover object-center", badge.image.className)
        }))));
    })))))))));
}

//# sourceMappingURL=WorkgroupHero.js.map